// removed by extract-text-webpack-plugin
module.exports = {"root":"src-components----speakerCard-module---root---1PVKj","compact":"src-components----speakerCard-module---compact---3qbFE src-components----speakerCard-module---root---1PVKj","name":"src-components----speakerCard-module---name---3laKW","company":"src-components----speakerCard-module---company---1op0k"};


//////////////////
// WEBPACK FOOTER
// ./src/components/speakerCard.module.scss
// module id = 449
// module chunks = 168707334958949